import React from "react";
import { buildPlanningOrderEditPresentation } from "../utils/planningOrderEditDiagnostics.js";

export default function PlanningOrderEditCaptureDetails({ item }) {
  const presentation = buildPlanningOrderEditPresentation(item);
  if (!presentation) return null;
  return (
    <div
      className="grid min-w-0 gap-1 rounded-[4px] border border-slate-200 bg-slate-50/80 px-2 py-1 [overflow-wrap:anywhere]"
      data-order-edit-details="true"
    >
      <span className="text-[0.52rem] font-extrabold uppercase tracking-[0.07em] text-slate-500">Modification depuis le Gantt</span>
      <strong className="min-w-0 whitespace-pre-wrap text-[0.76rem] leading-tight text-slate-950">{presentation.identity}</strong>
      {presentation.notices.map((notice) => (
        <p className="m-0 text-[0.68rem] leading-4 text-slate-600" key={notice}>{notice}</p>
      ))}
      {presentation.lines.length ? (
        <ul className="m-0 grid list-none gap-0 p-0 text-[0.68rem] leading-4 text-slate-700">
          {presentation.lines.map((line) => <li className="whitespace-pre-wrap" key={line}>{line}</li>)}
        </ul>
      ) : null}
      {presentation.diagnosticRows.length ? (
        <dl className="m-0 mt-1 grid gap-0.5 border-t border-slate-200 pt-1 text-[0.68rem] leading-4">
          {presentation.diagnosticRows.map(({ label, value }) => (
            <div key={label}><dt className="inline font-semibold">{label} : </dt><dd className="m-0 inline whitespace-pre-wrap">{value}</dd></div>
          ))}
        </dl>
      ) : null}
    </div>
  );
}
